module.exports = __webpack_public_path__ + "static/media/roxanna.e80c307c.JPG";